<template>
  <div class="col-md-4 summary-card-col">
    <div class="summary-card">
      <div class="summary-card-header">
        <span class="summary-title">{{ statisticsItem[itemKey].data.name }}</span>
        <span @click="navigate(statisticsItem[itemKey].data.url)" class="summary-see-all">See All</span>
      </div>
      <p class="chart-empty-state" v-if="statisticsItem[itemKey].data.data.length == 0">No data available</p>
      <div v-else class="summary-table-scroll">
        <table class="summary-table">
          <tbody>
          <tr v-for="(list, key) in  statisticsItem[itemKey].data.data" :key="key">
            <th scope="row">{{ ++key }}</th>
            <td class="text-start">
              <div class="cut-text">
                {{ list.name }}
              </div>
            </td>
            <td class="text-end">{{ commaFormat(list.amount) }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import {useRoute, useRouter} from "vue-router";
import useDate from "@/services/utils/day";
import figureFormatter from "@/services/utils/figureFormatter";

const {firstDateOfMonth, lastDateOfMonth} = useDate()

const router = useRouter()
const route = useRoute()
const {commaFormat} = figureFormatter()

defineProps({
  statisticsItem: Object,
  page: Object,
  itemKey: String
})

function navigate(url) {
  router.push({name: url, params: route.params, query: {start: firstDateOfMonth, end: lastDateOfMonth}})
}

</script>

<style scoped>
.summary-card-col {
  padding: 8px;
}

.summary-card {
  background-color: #ffffff;
  border: 1px solid #e8e9ec;
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(34, 41, 47, 0.06);
  padding: 18px 20px;
  height: 235px;
  display: flex;
  flex-direction: column;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.summary-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 24px rgba(34, 41, 47, 0.12);
}

.summary-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  margin-bottom: 8px;
  border-bottom: 1px solid #f0f1f4;
}

.summary-title {
  font-size: 13.5px;
  font-weight: 700;
  color: #2b2b2b;
}

.summary-see-all {
  font-size: 12px;
  font-weight: 600;
  color: #16a085;
  cursor: pointer;
}

.summary-table-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

.summary-table {
  width: 100%;
  font-size: 13px;
}

.summary-table tr:not(:last-child) {
  border-bottom: 1px solid #f5f6f8;
}

.summary-table th,
.summary-table td {
  padding: 7px 4px;
  color: #4a4a4a;
  font-weight: 400;
}

.chart-empty-state {
  text-align: center;
  color: #8a8a8a;
  font-size: 13px;
  padding: 40px 0;
}
</style>
